import { css, styled } from 'styled-components';

export function ProfessionalSummaryDataTable(props: { children: React.ReactNode; isRead?: boolean }) {
    return (
        <StyledScrollContainer $isRead={props.isRead}>
            <StyledTable>{props.children}</StyledTable>
        </StyledScrollContainer>
    );
}

const StyledScrollContainer = styled.div<{ $isRead?: boolean }>`
    width: 100%;
    overflow-x: auto;

    ${(props) =>
        !props.$isRead &&
        css`
            ${({ theme }) => theme.mediaQueries.small} {
                overflow-x: visible;
            }
        `}
`;

const StyledTable = styled.table`
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    border-spacing: 0;
    border-collapse: collapse;

    thead {
        th {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #50463f;
            padding: 0.5rem;
            vertical-align: middle;

            &.has-checkbox {
                width: 36px;
                min-width: 36px;
            }
        }
    }

    tbody {
        tr {
            td {
                font-weight: 400;
                font-size: 14px;
                color: #322a24;
                vertical-align: middle;
                line-height: 21px;
                padding: 6px 8px;

                &.has-textinput {
                    vertical-align: baseline;

                    @media (width <= 576px) {
                        min-width: 224px;
                    }
                }

                &.has-datepicker {
                    vertical-align: baseline;
                    white-space: nowrap;

                    @media (width <= 576px) {
                        min-width: 128px;
                    }
                }

                &.has-checkbox {
                    width: 36px;
                    min-width: 36px;
                    padding: 0 8px;
                }

                .rw-popup-container {
                    @media (width <= 576px) {
                        position: static !important;
                    }
                }
            }

            &.active {
                td {
                    font-weight: 500;
                }
            }
        }
    }

    .rw-widget {
        width: 100%;
        font-size: 0.875rem;

        .rw-widget-picker {
            .rw-select {
                padding: 0;
                margin: 0;
                line-height: 1;
            }

            .rw-btn {
                height: auto;
                background-size: 16px;
                background-position: 0 -2px;
            }
        }

        input[type='text'] {
            width: calc(100% - 25px);
            padding: 0;
            line-height: 1;
            min-height: auto;
        }
    }
`;
